// VERSION STABLE

import React, { useState, useEffect } from "react";
import { Typography, Button, CircularProgress, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import background1 from "../../Images/bg_opening1.jpeg";
import background2 from "../../Images/bg_opening2.png";
import cardBack from "../../Images/cardBack.jpeg";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

import { useGetUserConnecteData } from "../Utilisateur/Component/RecupererDonneeUser";

export default function PackOpening() {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  const [isOpening, setIsOpening] = useState(false);
  const [flashActive, setFlashActive] = useState(false);
  const [clicks, setClicks] = useState(0);
  const [showTypography, setShowTypography] = useState(true);
  const [animateCard, setAnimateCard] = useState(false);
  const [slideUp2Active, setSlideUp2Active] = useState(false);
  // eslint-disable-next-line
  const [currentBack, setCurrentBack] = useState(cardBack);
  const [currentImage, setCurrentImage] = useState(currentBack);
  const [showButton, setShowButton] = useState(false);

  const UidCurrentUser = localStorage.getItem("userUid");
  const uData = useGetUserConnecteData(UidCurrentUser);
  const userData = uData.userData;
  const [isLoading, setIsLoading] = useState(true);

  const idOrganisation = localStorage.getItem("idOrganisation");

  const [collectionData, setCollectionData] = useState(null);
  const [idCollection, setIdCollection] = useState(null);

  const [itemsByRarity, setItemsByRarity] = useState({
    commune: [],
    rare: [],
    ultraRare: [],
  });

  const [ultraRareCard, setUltraRareCard] = useState([]);
  const [rareCard, setRareCard] = useState([]);
  const [communeCard, setCommuneCard] = useState([]);

  useEffect(() => {
    const storedCollection = localStorage.getItem("selectedCollection");
    // Vérifier que les données sont présentes et valides
    if (storedCollection) {
      const data = JSON.parse(storedCollection);
      setCollectionData(data);
      setIdCollection(data.idCollection);

      // Extraire uniquement les IDs des items dans chaque dossier (commune, rare, ultraRare)
      const communeItems = data?.commune ? Object.keys(data.commune) : [];
      const rareItems = data?.rare ? Object.keys(data.rare) : [];
      const ultraRareItems = data?.ultraRare ? Object.keys(data.ultraRare) : [];

      // Mettre à jour le state avec les IDs des items
      setItemsByRarity({
        commune: communeItems,
        rare: rareItems,
        ultraRare: ultraRareItems,
      });
    }
    setIsLoading(false);
  }, []);

  const [counter, setCounter] = useState("0");

  useEffect(() => {
    if (!isLoading && collectionData) {
      let localCounter = counter;

      const fetchUrls = (items, category) => {
        return items.map((id) => {
          const urlId = collectionData?.[category]?.[id];
          const url = collectionData?.urls?.[urlId];

          const title = localCounter.toString().padStart(3, "0");
          localCounter++;

          return {
            id,
            title: title,
            imageUrl: url || "",
          };
        });
      };

      const ultraRare = fetchUrls(itemsByRarity.ultraRare, "ultraRare");
      const rare = fetchUrls(itemsByRarity.rare, "rare");
      const commune = fetchUrls(itemsByRarity.commune, "commune");

      setUltraRareCard(ultraRare);
      setRareCard(rare);
      setCommuneCard(commune);
      console.log("Cartes ultra rares :", ultraRare);

      setCounter(localCounter);
    }
  }, [isLoading, collectionData, counter, itemsByRarity]);

  useEffect(() => {
    const isOpeningLocal = JSON.parse(localStorage.getItem("opening"));
    if (!isOpeningLocal) {
      navigate("/collection");
    }
  }, [navigate]);

  // Pré-chargement des images pour améliorer les performances
  const preloadImages = (imageUrls) => {
    imageUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  };

  useEffect(() => {
    if (ultraRareCard.length || rareCard.length || communeCard.length) {
      const allImages = [
        background1,
        background2,
        cardBack,
        ...ultraRareCard.map((c) => c.imageUrl),
        ...rareCard.map((c) => c.imageUrl),
        ...communeCard.map((c) => c.imageUrl),
      ];
      preloadImages(allImages);
    }
  }, [ultraRareCard, rareCard, communeCard]);

  // Fonction pour appeler l'API backend pour ouvrir un pack
  const openPack = async () => {
    try {
      setIsOpening(true);
      localStorage.removeItem("opening"); // Supprime l'état "opening"

      // Appel à l'API backend
      const response = await fetch(
        "https://backend-betkiff.vercel.app/card/openPackNew",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idUser: userData.idUser,
            cardsData: {
              ultraRareCard,
              rareCard,
              communeCard,
            },
            idOrganisation,
            idCollection,
          }),
        }
      );

      const data = await response.json();
      console.log("Données de la carte ouverte :", data);

      if (data.success) {
        const drawnCard = data.card;
        console.log("Carte tirée :", drawnCard.imageUrl);
        setCards([drawnCard]);
        setIsOpening(false);

        setTimeout(() => {
          setCurrentImage(drawnCard.imageUrl); // Change l'image après un tour
        }, 1000);

        setAnimateCard(true);
        setTimeout(() => setShowButton(true), 3000);
      } else {
        console.error("Erreur lors de l'ouverture du pack :", data.error);
      }
    } catch (error) {
      console.error("Erreur réseau :", error);
    }
  };

  // Gestion des clics pour déclencher l'ouverture du pack
  const handleClick = () => {
    setClicks((prev) => prev + 1);

    // Active un flash temporaire
    setFlashActive(true);
    setTimeout(() => setFlashActive(false), 100);

    if (clicks >= 4) {
      setShowTypography(false);
      openPack();
    }
  };

  // Gestion de l'animation et navigation après ouverture
  const handleSlideUp2 = () => {
    setSlideUp2Active(true);
    setShowButton(false);
    setTimeout(() => {
      navigate("/collection");
      window.location.reload(); // Forcer le rechargement de la page
    }, 1000);
  };
  return (
    <div style={{ position: "fixed", width: "100%", height: "100vh" }}>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100vh",
          overflow: "hidden",
          textAlign: "center",
        }}
      >
        {showTypography && (
          <Typography
            variant="h4"
            onClick={handleClick}
            sx={{
              fontWeight: "bold",
              color: "rgb(68, 1, 104)",
              zIndex: 3,
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: `${1 + clicks * 0.2}em`,
              transition: "transform 0.2s",
            }}
          >
            TAP HERE !
          </Typography>
        )}
        {showButton && cards.length > 0 && (
          <Box
            onClick={handleSlideUp2}
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 10,
              backgroundColor: "transparent", // Maintient un arrière-plan transparent
              cursor: "pointer", // Ajoute un pointeur pour indiquer que c'est cliquable
            }}
          >
            <Button
              variant="outlined"
              sx={{
                position: "absolute", // Permet un positionnement contrôlé
                top: "10vh", // Place le bouton à 20% de la hauteur de la page
                left: "50%", // Centre le bouton horizontalement
                transform: "translateX(-50%)", // Recentre le bouton après le décalage dû à `left: 50%`
                borderColor: "#7000b5",
                color: "#7000b5",
                animation: "pulse 1.5s infinite",
                zIndex: 11, // Assure que le bouton reste au-dessus
                pointerEvents: "none", // Empêche le bouton de capturer les clics
                "&:hover": {
                  borderColor: "rgb(68, 1, 104)",
                  color: "rgb(68, 1, 104)",
                },
                "@keyframes pulse": {
                  "0%": { boxShadow: "0 0 0 0 rgba(128, 0, 128, 0.4)" },
                  "70%": { boxShadow: "0 0 30px 30px rgba(128, 0, 128, 0)" },
                  "100%": { boxShadow: "0 0 0 0 rgba(128, 0, 128, 0)" },
                },
              }}
            >
              <ArrowUpwardIcon />
            </Button>
          </Box>
        )}

        <img
          src={background1}
          alt="Background 1"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
          }}
        />

        {isOpening && (
          <div style={{ zIndex: 3, position: "relative" }}>
            <CircularProgress />
          </div>
        )}

        {!isOpening && cards.length > 0 && (
          <div
            style={{
              position: "absolute",
              left: "50%",
              bottom: "50%",
              transform: "translate(-50%, 50%)",
              zIndex: 2,
              animation: slideUp2Active
                ? "slideUp2 1s ease-in-out forwards"
                : "slideUp 1s ease-in-out forwards",
            }}
          >
            <img
              src={currentImage}
              alt="Card"
              style={{
                borderRadius: "10px",
                width: "200px",
                height: "auto",
                zIndex: 200,
                animation: animateCard
                  ? "rotateCard 2s ease-out forwards"
                  : "none",
              }}
              onAnimationEnd={() => setAnimateCard(false)}
            />
          </div>
        )}

        <img
          src={background2}
          alt="Background 2"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 4,
            pointerEvents: "none",
          }}
        />

        {flashActive && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "white",
              opacity: 0.8,
              zIndex: 5,
              animation: "flash 0.1s linear",
            }}
          />
        )}

        <style>
          {`
@keyframes slideUp {
            0% {
              transform: translateX(-50%) translateY(200%);
            }
            50% {
              transform: translateX(-50%) translateY(50%);
            }
            100% {
              transform: translateX(-50%) translateY(50%);
            }
          }

  .element {
    animation: slideUp 1s ease-in-out forwards;
    will-change: transform;
  }

          @keyframes slideUp2 {
            0% {
              transform: translateX(-50%) translateY(50%);
              opacity: 1;
            }
            100% {
              transform: translateX(-50%) translateY(-200%);
             
            }
          }
          @keyframes rotateCard {
            0% {
              transform: rotateY(0deg);
              background-image: url('${currentBack}');
            }
            50% {
              transform: rotateY(2160deg);
              background-image: url('${currentBack}');
            }
            60% {
              transform: rotateY(2700deg);
              background-image: url('${cards[0]?.imageUrl || ""}');
            }
            100% {
              transform: rotateY(3240deg);
              background-image: url('${cards[0]?.imageUrl || ""}');
            }
          }   
          @keyframes flash {
            0% {
              opacity: 0.8;
            }
            100% {
              opacity: 0;
            }
          }
          }
          `}
        </style>
      </div>
    </div>
  );
}
